export default __webpack_public_path__ + "static/img_9103-83b868e39857e70abb9fc79f6435cff2.png";